import React from 'react';
import { Section } from './ui/Section';
export function VideoSection() {
  return <Section background="white" id="video" data-id="element-235">
      <div className="max-w-4xl mx-auto text-center" data-id="element-236">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8" data-id="element-237">
          Mira cómo funciona tu nueva mentora
        </h2>

        <div className="relative w-full overflow-hidden rounded-2xl shadow-2xl bg-gray-900" style={{
        paddingTop: '56.25%'
      }} data-id="element-238">
          <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/OgHZS-Zo4ms" title="Dra Sophi - Mentora de Comunicación" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-239"></iframe>
        </div>
      </div>
    </Section>;
}